import { Form } from "react-bootstrap";

export function CustomerSelect({ customers, value, onChange }) {
  if (!customers || customers.length <= 1) return null;
  return (
    <Form.Select
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className="customer-select"
      aria-label="Select customer"
    >
      <option value="">Select customer…</option>
      {customers.map((c) => (
        <option value={c.code} key={c.code}>
          {c.name}
        </option>
      ))}
    </Form.Select>
  );
}
